/**
 * Copyright 2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { When } from "react-if";
import { Sidebar } from "@nordcloud/gnui";
import { CloudAccount } from "~/views/cloudAccounts/types";
import { isKubernetesOrOpenshift, isVMWare } from "~/views/cloudAccounts/utils";
import { KubernetesOpenshiftDocumentationForm } from "./KubernetesOpenshiftDocumentationForm";
import { VmwareDocumentationForm } from "./VmwareDocumentationForm";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  account: CloudAccount;
};

export function HybridCloudDocumentationSidebar({
  isOpen,
  onClose,
  account,
}: Props) {
  const isK8sOrOpenshift = account.providerType
    ? isKubernetesOrOpenshift(account.providerType)
    : false;
  return (
    <Sidebar
      width="47rem"
      isOpen={isOpen}
      title="Onboarding Documentation"
      onClick={onClose}
    >
      <When condition={isVMWare(account.providerType)}>
        <VmwareDocumentationForm account={account} />
      </When>

      <When condition={isK8sOrOpenshift}>
        <KubernetesOpenshiftDocumentationForm />
      </When>
    </Sidebar>
  );
}
